<template>
  <v-snackbar
    v-model="toast.show"
    :color="toast.type"
    dark
  >
    <strong v-if="toast.title">{{ toast.title }}</strong>
    <div v-html="toast.text" />

    <template #action="{ attrs }">
      <qz-btn
        color="black"
        data-test="close-toast"
        class="white--text"
        text
        v-bind="attrs"
        @click="hideToast"
      >
        Close
      </qz-btn>
    </template>
  </v-snackbar>
</template>
<script>
import {
  mapActions,
  mapState,
} from 'vuex';

export default {
  name: 'qz-snackbar',
  computed: {
    ...mapState(['toast']),
  },
  methods: {
    ...mapActions(['hideToast']),
  },
};
</script>
